var cilFunctionsAlt = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='128 416 360 416 360 384 160 384 160 374.283 269.834 256 160 137.717 160 128 360 128 360 96 128 96 128 150.283 226.166 256 128 361.717 128 416' class='ci-primary'/>"];

export { cilFunctionsAlt };

